export const splitLongNames = (name: string, width: number) => {
  if (!name) {
    return '';
  }
  const removeSpaces = name.replace(' / ', '/');
  const splittedNameSlash = removeSpaces.split('/');
  if (name.length < width) {
    return name;
  } else {
    if (splittedNameSlash.length === 2) {
      return '.../' + splittedNameSlash[1];
    } else if (splittedNameSlash.length > 2) {
      if (
        splittedNameSlash[splittedNameSlash.length - 2].length +
          splittedNameSlash[splittedNameSlash.length - 1].length <
        width
      ) {
        return (
          '.../' +
          splittedNameSlash[splittedNameSlash.length - 2] +
          '/' +
          splittedNameSlash[splittedNameSlash.length - 1]
        );
      } else if (
        splittedNameSlash[splittedNameSlash.length - 2].length < width &&
        splittedNameSlash[splittedNameSlash.length - 1].length > width
      ) {
        return (
          '.../' + splittedNameSlash[splittedNameSlash.length - 2] + '/...'
        );
      } else {
        return '.../' + splittedNameSlash[splittedNameSlash.length - 1];
      }
    }
    return name;
  }
};

export const capitalizeFirstLetter = (text: string) => {
  return text.charAt(0).toUpperCase() + text.slice(1);
};
